import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { FatFingerDetail } from 'api'
import { fatFingerDetailsSelector } from 'selectors/fatFingerSelectors'
import { DataGrid, GridId } from 'view/components/datagrid'
import { fatFingerGridOptions, FatFingerColumnDefs } from './FatFingerGridModel'

interface FatFingerGridProps {
  fatFingerList: FatFingerDetail[]
}

const mapStateToProps = createStructuredSelector({
  fatFingerList: fatFingerDetailsSelector
})

export const FatFingerGridComponent: React.FunctionComponent<FatFingerGridProps> = props => {
  return (
    <DataGrid
      gridId={GridId.AdminFatFingerGrid}
      gridOptions={fatFingerGridOptions}
      rowData={props.fatFingerList}
      columnDefs={FatFingerColumnDefs}
    />
  )
}

export const FatFingerGrid = connect(mapStateToProps)(FatFingerGridComponent)
